import { render, staticRenderFns } from "./addMsgtplCate.vue?vue&type=template&id=4f360c94&scoped=true"
import script from "./addMsgtplCate.vue?vue&type=script&lang=js"
export * from "./addMsgtplCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f360c94",
  null
  
)

export default component.exports